/**
 * Decide whether to drop the “Recebendo configuração…” cue after a registration-status push.
 * Prefer holding through the CAMPAIGN_UPDATE / soft-defer handoff so the Org row never blanks.
 */

export type TContentChangeReceivingCueDecision = 'clear' | 'wait'

export function shouldClearContentChangeReceivingCue(options: {
  hasPendingPlaylistSwap: boolean
  hasDeferredRegistrationRoot: boolean
  /** Registration identity already differs from Feed / lastSet (GET applied, CAMPAIGN_UPDATE lag). */
  registrationAheadOfPlayback?: boolean
  elapsedMs: number
  minVisibleMs: number
  settleGraceMs: number
  holdMaxMs: number
}): TContentChangeReceivingCueDecision {
  if (options.hasPendingPlaylistSwap) {
    return 'clear'
  }
  if (!(options.elapsedMs >= 0) || !Number.isFinite(options.elapsedMs)) {
    return 'wait'
  }
  if (options.elapsedMs >= options.holdMaxMs) {
    return 'clear'
  }
  if (options.hasDeferredRegistrationRoot || options.registrationAheadOfPlayback === true) {
    return 'wait'
  }
  if (options.elapsedMs < options.minVisibleMs + options.settleGraceMs) {
    return 'wait'
  }
  return 'clear'
}
